export enum DataHoraordemDeCargaTypes {
  'LOAD_REQUEST' = '@dataHoraordemDeCarga/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@dataHoraordemDeCarga/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@dataHoraordemDeCarga/LOAD_FAILURE',

  'CLEAN_MOVIENTRADA' = '@dataHoraordemDeCarga/CLEAN_MOVIENTRADA',
}
export interface IDataHoraordemDeCarga {
  dtAgendamento: string;
  codHorario: number;
  codPlataforma: number;
  dhAgendamento: string;
}

export interface DataHoraordemDeCargaState {
  readonly data: IDataHoraordemDeCarga | [];
  readonly loading: boolean;
  readonly error: boolean;
}
